// Generated by ReScript, PLEASE EDIT WITH CARE


function reducer(state, action) {
  if (typeof action === "number") {
    return {
            data: state.data,
            filter_request: state.filter_request,
            offset: state.offset,
            end_of_list: state.end_of_list,
            selected_filter: undefined,
            total_items: state.total_items
          };
  }
  switch (action.TAG | 0) {
    case /* SetData */0 :
        return {
                data: action.data,
                filter_request: state.filter_request,
                offset: action.offset,
                end_of_list: action.end_of_list,
                selected_filter: state.selected_filter,
                total_items: action.total_items
              };
    case /* BeforeDataFetch */1 :
        return {
                data: action.data,
                filter_request: action.filter_request,
                offset: state.offset,
                end_of_list: state.end_of_list,
                selected_filter: state.selected_filter,
                total_items: state.total_items
              };
    case /* SetSelectedFilter */2 :
        var selected_filter = action._0;
        return {
                data: state.data,
                filter_request: selected_filter.filter_props,
                offset: state.offset,
                end_of_list: state.end_of_list,
                selected_filter: selected_filter,
                total_items: state.total_items
              };
    
  }
}

export {
  reducer ,
  
}
/* No side effect */
